import { GridIcon } from '@/features/experiences/components/Controls/controls/LayoutControl/GridIcon';

export const Box2RowIcon = () => {
  return (
    <GridIcon shapeProps={{ height: '24px' }} squareCols={3} squareRows={2} />
  );
};
